import axios from "axios";

export const BRANCH_URL = "/Branch";
export const PERSON_ASSIGNMENT_URL = "/PersonAssignment";

/** Mevcut Okulun Duyuru Grubu Listesini Elde Eder */
export function getList() {
  return axios.get(PERSON_ASSIGNMENT_URL);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğretmen ve Duyuru Grubu Listesini Elde Eder */
export function getTeacherAndNoticeGroups(queryParams) {
  return axios.post(`${PERSON_ASSIGNMENT_URL}/GetTeacherAndNoticeGroups`, queryParams);
}

/** Mevcut Okulun Mevcut Dönemdeki Belli Bir Öğretmen ve Duyuru Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllTeacherAndNoticeGroups(queryParams) {
  return axios.post(`${PERSON_ASSIGNMENT_URL}/GetAllTeacherAndNoticeGroups`, queryParams);
}

/** Mevcut Okulun Duyuru Grubu Listesini Elde Eder */
export function getNoticeGroups() {
  return axios.get(`${PERSON_ASSIGNMENT_URL}/GetNoticeGroups`);
}

/** Mevcut Okulun Belli Bir Öğretmen Listesini Elde Eder */
export function getTeachers(queryParams) {
  return axios.post(`${PERSON_ASSIGNMENT_URL}/GetTeachers`, queryParams);
}

/** Mevcut Okulun Branş Listesini Elde Eder */
export function getBranches() {
  return axios.get(`${BRANCH_URL}/GetBranches`);
}

/** Belli Bir Duyuru Grubuna Ait Kişi Listesinin Id lerini Elde Eder */
export function getPersonIds(noticeGroupId, receipentType) {
  return axios.get(`${PERSON_ASSIGNMENT_URL}/${noticeGroupId}/${receipentType}`);
}

/** Belli Bir Duyuru Grubuna Ait Kişi Listesini Kaydeder */
export function savePeople(receipentType, noticeGroupId, personIds) {
  return axios.post(PERSON_ASSIGNMENT_URL, { receipentType, noticeGroupId, personIds });
}
